<template>

    <fieldset id="order-details">
        <div class="order-info-block" v-show="deliveryOptionsErrors.parts">
            <p class="error-message">Prosimy o dodanie przynajmniej jednego numeru zamówienia wraz z jego wartością.</p>
        </div>

        <!-- dni dostawy -->
        <div class="order-header">
            <i class="ion-android-calendar"></i>
            <h2>Wybierz preferowany dzień dostawy</h2>
            <div class="order-info-block"><p class="disclaimer">UWAGA: Wybrany termin oznacza preferowany dzień dostawy, który może ulec zmianie w toku planowania. W przypadku zaistnienia takiej sytuacji pracownik POK skontaktuje się telefonicznie w celu umówienia ostatecznego terminu realizacji.</p></div>
        </div>

        <div class="formFieldWrap">
            <div class="option-container">
                <div v-bind:class="{ 'option-active': d.date == currentDate.date }" v-on:click="selectDate(d);" class="option4 order-promoted-option" v-for="(d, index) in threeAvailableDates">
                    <h5>{{d.date}}</h5>
                    <p>({{d.dayName}})</p>
                </div>

                <div class="option4" v-on:click="clickAllDates()" v-bind:class="{ 'option-active': showAllDates == true }">
                    <h5>{{otherDates.date}}</h5>
                    <p>({{otherDates.note}})</p>
                </div>
            </div>
        </div>

        <div class="formFieldWrap">

            <select v-show="showAllDates" v-model="selDate">
                <option value="">Wybierz preferowany dzień dostawy</option>
                <option v-for="d in availableDates"
                        :selected="currentDate"
                        :value="d.date">{{d.date}} ({{d.dayName}})</option>
            </select>
        </div>
        <div class="order-info-block" v-show="deliveryOptionsErrors.date">
            <p class="error-message">Prosimy o wybór preferowanego dnia dostawy.</p>
        </div>

        <!-- przedzial godzinowy -->
        <div class="order-header">
            <i class="ion-android-time"></i>
            <h2>Wybierz przedział godzinowy dostawy</h2>
        </div>

        <div class="formFieldWrap">
            <div class="option-container">
                <div class="option4 order-promoted-option"  v-bind:class="{ 'option-active': currentTimePeriod == timePeriods[0] }"  v-on:click="setTimePeriod(0);">
                    <svg>
                        <path class="st0" d="M42,14.1c0,1.7,0.4,3.3,1.2,4.6l8.1-4.7V4.8C46.2,4.8,42,9,42,14.1z"/>
                        <path class="st0" d="M51.4,0c-7.8,0-14.2,6.3-14.2,14.1s6.4,14.2,14.2,14.2s14.2-6.4,14.2-14.2C65.5,6.3,59.2,0,51.4,0z M60.6,18.6
											c-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.9,1.3-2,2.4-3.3,3.2L57,22.7c-0.2,0.1-0.4,0.3-0.7,0.4l0.5,0.9c-1.4,0.7-2.9,1.2-4.5,1.3v-1
											c-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7,0v1c-1.6-0.1-3.1-0.6-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9
											c-1.3-0.8-2.5-2-3.4-3.3l0.9-0.5c-0.5-0.3-0.8-0.8-1-1.2l-0.9,0.5c-0.7-1.4-1.1-2.9-1.1-4.5h1c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.4
											h-1c0.1-1.6,0.5-3.2,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.9-1.3,2-2.4,3.3-3.2l0.5,0.9c0.2-0.1,0.4-0.3,0.7-0.4
											l-0.5-0.9C47.5,3.6,49,3.1,50.6,3v1c0.2,0,0.5,0,0.7,0c0.3,0,0.5,0,0.7,0V3c1.6,0.1,3.1,0.6,4.5,1.3L56,5.2
											c0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,2,3.4,3.3l-0.9,0.5c0.3,0.4,0.5,0.8,0.7,1.3l0.9-0.5c0.7,1.4,1.1,2.9,1.1,4.5h-1
											c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.4h1c-0.1,1.6-0.5,3.2-1.1,4.6L60.6,18.6z"/>
                    </svg>
                    <h5>{{timePeriods[0]}}</h5>
                </div>
                <div class="option4 order-promoted-option" v-bind:class="{ 'option-active': currentTimePeriod == timePeriods[1] }"  v-on:click="setTimePeriod(1);">
                    <svg>
                        <path class="st0" d="M56.2,6.1c-1.5-0.8-3-1.2-4.6-1.3v9.4l8,4.6C62.2,14.4,60.5,8.6,56.2,6.1z"/>
                        <path class="st0" d="M63.7,21.2c3.9-6.8,1.6-15.5-5.2-19.4S43.1,0.3,39.2,7.1c-3.9,6.7-1.6,15.4,5.2,19.3S59.8,28,63.7,21.2z
											 M43,19.9c-0.2-0.4-0.5-0.9-0.7-1.3l-0.9,0.5c-0.7-1.4-1.1-2.9-1.1-4.5h1c0-0.3,0-0.5,0-0.8h-1c0-1.6,0.4-3.1,1.1-4.6l0.9,0.5
											c0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.2,0.3-0.4,0.4-0.6l-0.8-0.5c0.9-1.3,2-2.4,3.3-3.2L46,5.6c0.2-0.1,0.5-0.3,0.7-0.4l-0.5-0.9
											C47.5,3.6,49,3.1,50.7,3v1c0.5,0,1,0,1.5,0V3c1.5,0.1,3,0.5,4.5,1.3l-0.5,0.9c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2
											l0.5-0.9c1.4,0.9,2.5,2,3.4,3.3l-0.9,0.5c0.3,0.4,0.5,0.8,0.7,1.3l0.9-0.5c0.7,1.4,1.1,2.9,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1
											c0,1.6-0.4,3.1-1.1,4.6l-0.9-0.5c-0.1,0.2-0.2,0.4-0.3,0.7c-0.1,0.2-0.3,0.4-0.4,0.6l0.9,0.5c-0.9,1.3-2,2.4-3.3,3.2L57,22.8
											c-0.2,0.1-0.5,0.3-0.7,0.4l0.5,0.9c-1.4,0.7-2.9,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.5-0.1-3-0.5-4.5-1.3l0.5-0.9
											c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.1-0.3-0.2l-0.5,0.9c-1.4-0.9-2.5-2-3.4-3.3L43,19.9z"/>
                    </svg>
                    <h5>{{timePeriods[1]}}</h5>
                </div>
                <div class="option4 order-promoted-option" v-bind:class="{ 'option-active': currentTimePeriod == timePeriods[2] }"  v-on:click="setTimePeriod(2);">
                    <svg>
                        <path class="st0" d="M56,22.2c1.5-0.8,2.6-2,3.4-3.4l-8.1-4.7l-8,4.6C45.9,23.3,51.6,24.8,56,22.2z"/>
                        <path class="st0" d="M39.1,21.2c3.9,6.8,12.6,9.1,19.4,5.2S67.6,13.8,63.7,7c-4-6.7-12.6-9-19.4-5.1S35.2,14.5,39.1,21.2z M50.6,4
											c0.5,0,1,0,1.5,0V3c1.6,0.1,3.1,0.5,4.5,1.3l-0.5,0.9c0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,1.9,3.4,3.3l-0.9,0.5
											c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.3,0.7l0.9-0.5c0.7,1.4,1.1,3,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1c-0.1,1.6-0.4,3.1-1.1,4.6
											l-0.9-0.5c-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.8,1.3-2,2.4-3.3,3.2l-0.5-0.9c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
											l0.5,0.9c-1.4,0.8-3,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.6-0.1-3.1-0.5-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9
											c-1.3-0.8-2.5-1.9-3.4-3.3l0.9-0.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.4-0.6l-0.9,0.5c-0.7-1.4-1.1-3-1.1-4.5h1
											c0-0.3,0-0.5,0-0.8h-1c0.1-1.6,0.4-3.1,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.8-1.3,2-2.4,3.3-3.2l0.5,0.9
											c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.5-0.9c1.4-0.8,3-1.2,4.5-1.3V4z"/>
                    </svg>
                    <h5>{{timePeriods[2]}}</h5>
                </div>
                <div v-show="false" class="option4 order-promoted-option" v-bind:class="{ 'option-active': currentTimePeriod == timePeriods[3] }"  v-on:click="setTimePeriod(3);">
                    <svg>
                        <path class="st0" d="M39.1,21.2c3.9,6.8,12.6,9.1,19.4,5.2S67.6,13.8,63.7,7c-4-6.7-12.6-9-19.4-5.1S35.2,14.5,39.1,21.2z M50.6,4
											c0.5,0,1,0,1.5,0V3c1.6,0.1,3.1,0.5,4.5,1.3l-0.5,0.9c0.2,0.1,0.5,0.3,0.7,0.4l0.5-0.9c1.3,0.8,2.5,1.9,3.4,3.3l-0.9,0.5
											c0.1,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.2,0.4,0.3,0.7l0.9-0.5c0.7,1.4,1.1,3,1.1,4.5h-1c0,0.3,0,0.5,0,0.8h1c-0.1,1.6-0.4,3.1-1.1,4.6
											l-0.9-0.5c-0.2,0.4-0.5,0.9-0.7,1.3l0.9,0.5c-0.8,1.3-2,2.4-3.3,3.2l-0.5-0.9c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
											l0.5,0.9c-1.4,0.8-3,1.2-4.5,1.3v-1c-0.5,0-1,0-1.5,0v1c-1.6-0.1-3.1-0.5-4.5-1.3l0.5-0.9c-0.2-0.1-0.5-0.3-0.7-0.4l-0.5,0.9
											c-1.3-0.8-2.5-1.9-3.4-3.3l0.9-0.5c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2-0.2-0.3-0.4-0.4-0.6l-0.9,0.5c-0.7-1.4-1.1-3-1.1-4.5h1
											c0-0.3,0-0.5,0-0.8h-1c0.1-1.6,0.4-3.1,1.1-4.6l0.9,0.5c0.2-0.4,0.5-0.9,0.7-1.3l-0.8-0.5c0.8-1.3,2-2.4,3.3-3.2l0.5,0.9
											c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.5-0.9c1.4-0.8,3-1.2,4.5-1.3V4z"/>
                    </svg>
                    <h5>08:00 - 20:00</h5>
                </div>
            </div>
        </div>

        <div class="order-info-block" v-show="deliveryOptionsErrors.period">
            <p class="error-message">Prosimy o wybór preferowanego przedziału godzinowego dostawy.</p>
        </div>
    </fieldset>
</template>

<script>
    import moment from 'moment';
    export default {
        name: 'orderDetails',
        props: ['orderParts', 'address', 'warehouse'],
        data () {
            return {
                selDate: '',
                threeAvailableDates: [],
                availableDates: [],
                orderPartsError: false,
                orderPartErrorNum: false,
                orderPartErrorValue: false,
                showAllDates: false,
                deliveryOptionsError: false,
                kmOutsideZone: 0,
                zone: {
                    Symbol: '',
                    ID: ''
                },
                deliveryOptionsErrors: {
                    parts: false,
                    date: false,
                    period: false
                },

                orderPart: {
                    ordNumber: "Wpisz numer zamówienia",
                    ordValue: "Wpisz wartość zamówienia"
                },
                otherDates: {
                    date: "Inny termin",
                    note: 'Pokaż dostępne dni',
                    defaultDate: "Inny termin",
                    defaultNote: 'Pokaż dostępne dni'
                },
                timePeriods: [
                    "10:00 - 14:00",
                    "13:00 - 17:00",
                    "16:00 - 20:00"

                ],
                currentDate: '',
                currentTimePeriod: '10:00 - 14:00',
                urls: {
                    getDates: "/api/delivery/getDates/",
                    calculateDeliveryCost: '/api/delivery/calculateDeliveryCost',
                    getDeliveryData: '/api/delivery/getDeliveryData/',
                    getDeliveryPrice: '/api/delivery/test/getDelivPrice/'
                }
            }
        },

        watch: {
            selDate: function(val) {
                if (_.isEmpty(val)) {
                    this.showAllDates = false;
                    this.otherDates.date = this.otherDates.defaultDate;
                    this.otherDates.note = this.otherDates.defaultNote;
                } else {
                    this.otherDates.date = val;
                    var d = _.find(this.availableDates, {date: val});
                    console.log(d);
                    if (d) {
                        this.otherDates.note = d.dayName;
                        this.currentDate = {
                            moment: moment(d.date),
                            date: d.date,
                            dayName: d.dayName
                        }
                    }
                }
            }
        },

        mounted: function() {
            var self = this;

            self.setTimePeriod(self.timePeriods[0])

            Event.$on("kmDistance", function(km) {
                console.log('kmDistance' + km);
                km = km.replace('km', '')
                km = km.replace(',', '.')
                self.kmDistance = parseFloat(km);
            });

            Event.$on("kmOutZone", function(km) {
                console.log('kmOutZone' + km);
                self.kmOutsideZone = km;
            });

            Event.$on("orderStep", function(stepId) {
                if (stepId == 4) {
                    self.$http.post(self.urls.getDates, {postalCode: self.address.PostalCode, divisionId: self.warehouse.ID}).then(function (response) {
                        self.availableDates = response.data.dates;
                        self.threeAvailableDates = response.data.dates.slice(0, 3);
                    });
                    // Geokodowanie
                    var address = self.getStringAddress();
                    console.log('|' + address + '|')
                    if (_.isEmpty(_.trim(address))) {
                        return;
                    }
                    //self.$http.post("/api/delivery/geocodeAddress/", {address: address, divisionId: self.warehouse.ID}).then(function (response) {
                    var params = {
                        Origin: {
                            DivisionID: self.warehouse.ID
                        },
                        Target: {
                            Street: self.address.Street,
                            StreetNo: self.address.StreetNo,
                            City: self.address.City,
                            PostalCode: self.address.PostalCode
                        }
                    };
                    self.$http.post(self.urls.getDeliveryData, {delivParams: params}).then(function (response) {
                        // @TODO - dodac emit z informacja o km i koszcie?
                        console.log(response);
                        if (response.data.status == 'cant_geocode') {
                            alert('Nie można ustalić adresu');
                            self.$emit('setOrderStep', 2);
                        }
                        if (response.data.distance) {
                            self.$emit('setDelivDistance', parseFloat(response.data.distance));
                        }
                        if (response.data.customerLocation) {
                            self.$emit('setCustomerLocation', response.data.customerLocation);
                        }
                        if (response.data.zone) {
                            self.zone = response.data.zone;
                        }
                    });

                } else if (stepId == 5) {
                    self.validateDelivery();
                }
            });
        },

        methods: {

            checkCost: function() {
                var self = this;
                var params = {
                    Origin: {
                        DivisionID: self.warehouse.ID
                    },
                    Target: {
                        Street: self.address.Street,
                        StreetNo: self.address.StreetNo,
                        City: self.address.City,
                        PostalCode: self.address.PostalCode
                    }
                };
                params.orderValue = self.partsSum;
                self.$http.post(self.urls.calculateDeliveryCost, {delivParams: params}).then(function (response) {
                    if (response.data.calculation) {
                        self.$emit("setDeliveryCost", response.data.calculation.price);
                        console.log('response.data.calculation.price');
                        console.log(response.data.calculation.price);
                    }
                });
            },

            validateDelivery: function() {
                this.deliveryOptionsError = false;
                this.deliveryOptionsErrors.date = false;
                this.deliveryOptionsErrors.period = false;

                if (this.currentDate == '') {
                    this.deliveryOptionsErrors.date = true;
                    this.deliveryOptionsError = true;
                }

                if (_.isEmpty(this.currentTimePeriod) ) {
                    this.deliveryOptionsErrors.period = true;
                    this.deliveryOptionsError = true;
                }
                //currentDate
                this.$emit("setDeliveryOptionsError", this.deliveryOptionsError);
            },

            setTimePeriod: function(t) {
                console.log(t);
                var tp = this.timePeriods[t];
                this.currentTimePeriod = tp;
                this.$emit("setDelivTimePeriod", tp);
            },

            clickAllDates: function() {
                this.showAllDates = !this.showAllDates;
                this.currentDate = '';
            },

            selectDate: function(d) {
                this.currentDate = d;
                console.log(d);
                this.showAllDates = false;
                this.otherDates.date = this.otherDates.defaultDate;
                this.otherDates.note = this.otherDates.defaultNote;
                this.deliveryOptionsErrors.date = false;
                this.$emit("setDelivDate", d);
            },

            removePart: function(part) {
                this.$emit("removePart", part);
            },

            addPart: function() {
                console.log("addPart");
                var isValid = this.isValidOrderPart();
                if (!isValid) {
                    return;
                }

                this.orderPart.ordValue = parseFloat(this.orderPart.ordValue);
                this.$emit("addPart", this.orderPart);
                setTimeout(this.clearPart, 100);
            },

            isValidOrderPart: function() {
                console.log('isValidOrderPart');
                this.orderPartErrorNum = false;
                this.orderPartErrorValue = false;

                if (_.isEmpty(_.trim(this.orderPart.ordNumber)) || this.orderPart.ordNumber == "Wpisz numer zamówienia") {
                    this.orderPartErrorNum = true;
                }
                if (_.isEmpty(_.trim(this.orderPart.ordValue)) || this.orderPart.ordValue == "Wpisz wartość zamówienia") {
                    this.orderPartErrorValue = true;
                }

                var oValue = parseFloat(this.orderPart.ordValue);

                if (_.isNaN(oValue)) {
                    this.orderPartErrorValue = true;
                }
                if (this.orderPartErrorValue === true || this.orderPartErrorValue === true) {
                    return false;
                }
                return true;
            },

            clearPart: function() {
                this.orderPart.ordNumber = "";
                this.orderPart.ordValue = "";
            },

            getStringAddress: function() {
                return this.address.City + ' ' + this.address.Street + ' ' + this.address.StreetNo;
            }
        },

        computed: {
            partsSum: function() {
                if (_.isEmpty(this.orderParts)) {
                    return "0.00";
                }
                return _.sumBy(this.orderParts, 'ordValue').toFixed(2);
            }
        },

        filters: {
            toFixed: function(v) {
                return v.toFixed(2);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// OrderDetails.vue?12475576